import { render, staticRenderFns } from "./frontiertrends.vue?vue&type=template&id=16e8dab2&scoped=true&"
import script from "./frontiertrends.vue?vue&type=script&lang=js&"
export * from "./frontiertrends.vue?vue&type=script&lang=js&"
import style0 from "./frontiertrends.vue?vue&type=style&index=0&id=16e8dab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8dab2",
  null
  
)

export default component.exports